var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-datepicker", {
        attrs: {
          placeholder: _vm.placeholder,
          "date-formatter": _vm.dateFormatter,
          disabled: !_vm.picker,
          "max-date": new Date(),
          position: _vm.position,
          range: "",
        },
        on: { input: _vm.inputDate },
        model: {
          value: _vm.dates,
          callback: function ($$v) {
            _vm.dates = $$v
          },
          expression: "dates",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }